var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c(
        "div",
        {
          ref: "chatExtractRef",
          class: [
            "chat-extract",
            _vm.isShowDragMask ? "child-disable-click" : "",
          ],
          on: {
            dragenter: function ($event) {
              $event.preventDefault()
              return _vm.handleDragEnter.apply(null, arguments)
            },
            dragover: function ($event) {
              $event.preventDefault()
            },
            dragleave: function ($event) {
              $event.stopPropagation()
              return _vm.handleDragLeave.apply(null, arguments)
            },
            drop: function ($event) {
              $event.preventDefault()
              return _vm.handleDrop.apply(null, arguments)
            },
          },
        },
        [
          _c("FileUpload", {
            ref: "fileUploadRef",
            attrs: { "file-list": _vm.fileList },
            on: { query: _vm.getTaskList },
          }),
          _vm.isShowFileShow
            ? _c("FileShow", {
                attrs: {
                  loading: _vm.loading,
                  "is-no-more": _vm.isNoMore,
                  "page-params": _vm.pageParams,
                  "file-list": _vm.fileList,
                  "word-extract-index": _vm.wordExtractIndex,
                },
                on: {
                  "update:loading": function ($event) {
                    _vm.loading = $event
                  },
                  query: _vm.handleQueryFileShow,
                  search: _vm.handleSearchTaskList,
                  delete: _vm.handleDelete,
                },
              })
            : _c("div", { staticClass: "file-show-empty" }, [
                _c("img", {
                  attrs: { src: require("@/assets/image/aiIcon.gif") },
                }),
                _c("span", [_vm._v("暂未产生任意记录")]),
              ]),
        ],
        1
      ),
      _c("DragMask", {
        attrs: { visible: _vm.isShowDragMask },
        on: {
          "update:visible": function ($event) {
            _vm.isShowDragMask = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }